<script>
  import { onMount } from "svelte";
  import { t } from 'svelte-i18n';
  // library that creates chart objects in page
  import Chart from "chart.js";

  export let chartData = [];
  export let chartTitle = "Chart";

  let chartCanvas;
  let chart;

  // init chart
  onMount(async () => {
    if (!chartCanvas) return;

    const labels = chartData.map(item => item.label || '');
    const data = chartData.map(item => item.value || 0);

    var config = {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            label: chartTitle,
            backgroundColor: "#4c51bf",
            borderColor: "#4c51bf",
            data: data,
            fill: false,
            barThickness: 40,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: chartTitle,
          fontColor: "black",
        },
        legend: {
          labels: {
            fontColor: "black",
          },
          align: "end",
          position: "bottom",
        },
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "rgba(0,0,0,.7)",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Month",
                fontColor: "white",
              },
              gridLines: {
                display: false,
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(0, 0, 0, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(0,0,0,.7)",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Value",
                fontColor: "white",
              },
              gridLines: {
                borderDash: [3],
                borderDashOffset: [3],
                drawBorder: false,
                color: "rgba(0, 0, 0, 0.15)",
                zeroLineColor: "rgba(33, 37, 41, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [3],
              },
            },
          ],
        },
      },
    };

    var ctx = chartCanvas.getContext("2d");
    chart = new Chart(ctx, config);
  });

  // Update chart when data changes
  $: if (chart && chartData) {
    const labels = chartData.map(item => item.label || '');
    const data = chartData.map(item => item.value || 0);
    
    chart.data.labels = labels;
    chart.data.datasets[0].data = data;
    chart.data.datasets[0].label = chartTitle;
    chart.options.title.text = chartTitle;
    chart.update();
  }
</script>

<div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
  <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full max-w-full flex-grow flex-1">
        <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
          {$t('dashboard.statistics')}
        </h6>
        <h2 class="text-blueGray-700 text-xl font-semibold">
          {chartTitle}
        </h2>
      </div>
    </div>
  </div>
  <div class="p-4 flex-auto">
    <div class="relative h-350-px">
      <canvas bind:this={chartCanvas}></canvas>
    </div>
  </div>
</div>
